export const defaultImage =  "https://cdn.brightstonecloud.com/mems/mnm_placeholder_1735114675.jpg"

// 顶部
// export const bgtop = "https://cdn.brightstonecloud.com/mems/topbg_1735277869.png"
export const bgtop = "https://cdn.brightstonecloud.com/mems/bg22_1735280665.jpg"

// 404
export const notFound1 = "https://cdn.brightstonecloud.com/mems/404_1735279206.png"
export const notFound2 = "https://cdn.brightstonecloud.com/mems/404_cloud_1735279370.png"
